module.exports = __webpack_public_path__ + "img/icn-spec__disable--lightGray.cc8bdb63.svg";